import { render } from "./MaoLabel.vue?vue&type=template&id=1be11007&scoped=true"
import script from "./MaoLabel.vue?vue&type=script&lang=js"
export * from "./MaoLabel.vue?vue&type=script&lang=js"

import "./MaoLabel.vue?vue&type=style&index=0&id=1be11007&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1be11007"]])

export default __exports__